import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { ShieldCheck } from 'lucide-react'

export const DifferentiationSection = () => {
  return (
    <section className="py-24 bg-slate-900 text-white">
      <div className="container px-4 md:px-6 text-center max-w-3xl mx-auto">
        <ScrollReveal>
          <div className="flex justify-center mb-6">
            <ShieldCheck className="w-16 h-16 text-indigo-400" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Não vendemos software genérico.
          </h2>
          <p className="text-xl text-slate-300 leading-relaxed">
            Não vendemos software genérico nem soluções de IA abstratas. Criamos
            aplicações concretas, adaptadas ao negócio, onde a tecnologia
            trabalha em segundo plano para simplificar a operação e libertar
            tempo das equipas.
          </p>
        </ScrollReveal>
      </div>
    </section>
  )
}
